/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FieldRefDto } from './FieldRefDto';
import type { NestedUuidFilterDto } from './NestedUuidFilterDto';
export type UuidFilterDto = {
  /**
   * Equals filter for UUID values
   */
  equals?: string | FieldRefDto;
  /**
   * Greater than filter for UUID values
   */
  gt?: string | FieldRefDto;
  /**
   * Greater than or equal filter for UUID values
   */
  gte?: string | FieldRefDto;
  /**
   * In filter for UUID values
   */
  in?: Array<string> | FieldRefDto;
  /**
   * Less than filter for UUID values
   */
  lt?: string | FieldRefDto;
  /**
   * Less than or equal filter for UUID values
   */
  lte?: string | FieldRefDto;
  /**
   * Query mode for case sensitivity
   */
  mode?: UuidFilterDto.mode;
  /**
   * Not filter for UUID values
   */
  not?: string | NestedUuidFilterDto;
  /**
   * Not in filter for UUID values
   */
  notIn?: Array<string> | FieldRefDto;
};
export namespace UuidFilterDto {
  /**
   * Query mode for case sensitivity
   */
  export enum mode {
    DEFAULT = 'default',
    INSENSITIVE = 'insensitive',
  }
}
